import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { ThemeContext } from '../../ThemeContext';

const getColor = (percentage) => {
  if (percentage < 40) return "#FF4D4F"; // red
  if (percentage < 70) return "#aaa20b"; // yellow
  if (percentage < 90) return "#FFA500"; // orange
  return "#52C41A"; // green (90% and above)
};

const ProfileCompletionCircle = ({ percentage, size = 48, strokeWidth = 6, color, user, fields, getFieldDisplayName }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  const arcColor = color || getColor(percentage);

  let completed = [];
  let remaining = [];
  if (user && fields) {
    completed = fields.filter(field => user[field] && user[field].toString().trim() !== "");
    remaining = fields.filter(field => !user[field] || user[field].toString().trim() === "");
  }

  const tooltipContent = remaining.length > 0 ? (
    <div>
      <div><b>Remaining fields:</b>
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {remaining.map(f => <li key={f}>{getFieldDisplayName ? getFieldDisplayName(f) : f}</li>)}
        </ul>
      </div>
    </div>
  ) : "User Profile Completion";

  return (
    <ThemeContext.Consumer>
      {({ darkMode }) => (
        <Tooltip title={tooltipContent} arrow>
          <svg width={size} height={size} style={{ cursor: "pointer" }}>
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke={darkMode ? "#444" : "#eee"}
              strokeWidth={strokeWidth}
              fill="none"
            />
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              stroke={arcColor}
              strokeWidth={strokeWidth}
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.5s" }}
            />
            {/* <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy=".3em"
          fontSize={size * 0.32}
          fontWeight="bold"
          fill={darkMode ? "#ffffff" : "#333"}
        >
          {`${percentage}%`}
        </text> */}
          </svg>
        </Tooltip>
      )}
    </ThemeContext.Consumer>
  );
};

export default ProfileCompletionCircle;